import {matchPath} from 'react-router';

export const PrivateRoutes = {
  LANDING: '/',
  CREATE_INFERENCE_APP: '/project/:projectId/inference/:applicationId/create',
  CONFIGURE_INFERENCE_APP:
    '/project/:projectId/inference/:applicationId/deployment/:deploymentId/configure',
  VIEW_TEST_INFERENCE_APP:
    '/spa/project/:projectId/application/:applicationId/inference/:spaId/view',
  VIEW_DEPLOYMENT_INFERENCE_APP:
    '/spa/project/:projectId/application/:applicationId/deployment/inference/:spaId/view',
  INFERENCE_APP_DETAILS:
    '/spa/project/:projectId/application/:applicationId/inference/:spaId/details',
  DASHBOARD: '/dashboard',
  DATAVIEWER: '/project/:projectId/data/view',
  // TODO: Dataprepare is deprecated with the new dataset service. Remove once switch is complete
  DATAPREPARE: '/project/:projectId/data/prepare/:context',
  DATASET_EDIT: '/dataset/edit/:projectId/:datasetId',
  DATASET_CREATE: '/dataset/create/:projectId',
  DATASET_VIEW: '/dataset/:id',
  DATASET_LIST: '/dataset/list',

  DESIGN: '/project/:projectId/upload',
  TEST: '/project/:projectId/test',
  TEST_COMPARE: '/project/:projectId/test/compare',
  DEPLOY: '/project/:projectId/deployments/new',
  DEPLOY_INFERENCE_APP: '/project/:projectId/inference/:applicationId/deployments/new',
  DEPLOY_ALL: '/project/:projectId/deployments',
  DEPLOY_DETAILS: '/deployment/:deploymentId/details',
  DEPLOYMENT_RETRAIN: '/project/:projectId/retrain',
  DASHBOARD_DEPLOY: '/deployments/new',
  DASHBOARD_DEPLOY_ALL: '/deployments',
  MODELVIEWER: '/project/:projectId/model/view',
  SPA: '/spa/project/:projectId/*',
  PROJECT: '/project/:projectId/*',
  PROJECTLIST: '/project/list',
  SETTINGS: '/settings',
  FLOWGRAPH: '/project/:projectId/flowgraph/:ispId',
  MARKETPLACE: '/marketplace',
  POSTPROCESSOR_NEW: '/project/:projectId/postprocessor/new',
  POSTPROCESSOR_EDIT: '/project/:projectId/postprocessor/edit/:postProcessorId',
  PREPROCESSOR_NEW: '/project/:projectId/preprocessor/new',
  PREPROCESSOR_EDIT: '/project/:projectId/preprocessor/edit/:preProcessorId',
  HELP: '/guide',
};

export const getProjectId = pathname => {
  let index = 0;
  let match = null;
  const allowedPaths = [
    PrivateRoutes.PROJECT,
    PrivateRoutes.SPA,
    PrivateRoutes.DATASET_EDIT,
    PrivateRoutes.DATASET_CREATE,
  ];

  do {
    match = matchPath(pathname, allowedPaths[index]);
    index++;
  } while (!match && index < allowedPaths.length);

  return match?.params.projectId;
};
